import { axios } from "../../lib/axios";

export const DeleteCartPackage = (packageId: string) => {
    return axios.delete(`/cart/removePackageFromCart/${packageId}`)
        .then(response => response.data);
};